/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {useState, useEffect, useMemo} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {Form, Formik} from 'formik';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import {
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import {Breakpoints as breakpoints, EzFormControl, agentDeveloperUtils} from 'wobi-web-common';
import moment from 'moment';
import * as Yup from 'yup';
import {getImageByAgent} from '../../../config/agent';
import {createJourneyActivity, getFollowUpCallDates, createDialerFollowUp, updateContactFieldsByPotentialId} from '../../../utils/apiHandlers';
import useStyles from './useStyles';

// Constants
const SF_PREFIX = {
  LEAD: '00Q',
  OPPORTUNITY: '006',
};

const agentDeveloperName = agentDeveloperUtils.getAgentDeveloperName;

// validation schema
const validationSchema = Yup.object().shape({
  date: Yup.string().required('Date is required'),
  time: Yup.string().required('Time is required'),
}).test(
  'is-future',
  'Meeting must be in the future',
  (values) => {
    const {date, time} = values;

    if (!date || !time) {
 return true;
} // skip if not selected yet

    // Build a Date object like "2025-06-11T09:10:00"
    const combined = new Date(`${date}T${time}:00`);

    return combined > new Date();
  },
);

// Main component
const ScheduleCallPage = injectIntl(withRouter(({
  intl,
  isVerifyingPayment,
  formKey, // Add a key prop to force re-render
  isUseCardForBoth,
  isFirstCard,
  match,
  location,
}) => {
  const [dateOptions, setdateOptions] = useState([]);
  const [hourOptions, sethourOptions] = useState([]);
  const [datesAndHoursConfig, setDatesAndHoursConfig] = useState({});

  const {leadId, opportunityId, utm, extJourneyName, extMessageName, mediaType} = useMemo(() => {
    const potentialId = match?.params?.potentialId;
    if (!potentialId) {
 return {extJourneyName: null, extMessageName: null, leadId: null, mediaType: null, opportunityId: null, utm: null};
}

    const prefix = potentialId.slice(0, 3);
    const lead = prefix === SF_PREFIX.LEAD ? potentialId : null;
    const opp = prefix === SF_PREFIX.OPPORTUNITY ? potentialId : null;
    const queryParams = new URLSearchParams(location.search);

    return {extJourneyName: queryParams.get('Ext_Journey_Name'), extMessageName: queryParams.get('Ext_Message_Name'), leadId: lead, mediaType: queryParams.get('Media_Type'), opportunityId: opp, utm: queryParams.get('utm')};
  }, []);

  useEffect(() => {
    if (!leadId && !opportunityId || agentDeveloperName !== 'Wobi') {
 return;
}
    createJourneyActivity({
      action: 'Clicked',
      extJourneyName,
      extMessageName,
      leadId,
      location: 'schedule-call',
      mediaType,
      opportunityId,
      utm,
    });
  }, [leadId, opportunityId, utm]);

  useEffect(() => {
    const fetchOptions = async () => {
      const response = await getFollowUpCallDates();

      if (response && response.data) {
        const fullConfig = response.data;

        setDatesAndHoursConfig(fullConfig);

        const dates = Object.keys(fullConfig).sort();
        setdateOptions(dates);

        if (dates.length > 0) {
          const firstDate = dates[0];
          sethourOptions(fullConfig[firstDate]);
        }
      }
    };

    fetchOptions();
  }, []);

  // Hooks and utilities
  const messages = (id) => intl.formatMessage({id});
  const isMobile = useMediaQuery(`(max-width:${breakpoints.mobile}px)`);
  const classes = useStyles({isMobile});

  // Constants
 const INITIAL_MEETING_VALUES = {
    date: dateOptions.length > 0 ? dateOptions[0] : '',
    time: '',
  };

  const companyLogo = getImageByAgent('companyLogo.svg');
  const [showEnd, setShowEnd] = useState(false);

  const handleSubmit = async (values) => {
    if (agentDeveloperName === 'Wobi') {
    createJourneyActivity({
      action: 'Scheduled',
      extJourneyName,
      extMessageName,
      leadId,
      location: 'schedule-call',
      mediaType,
      opportunityId,
      utm,
    });
  }

     // Update contact fields (same as AskToContactThankYouPage)
    if (leadId || opportunityId) {
      await updateContactFieldsByPotentialId({
        mediaType: mediaType || 'SMS',
        potentialId: leadId || opportunityId,
      });
    }
    setShowEnd(true);

    // const potentialId = match?.params?.potentialId;

    // const {leadId, opportunityId} = getLeadAndOpportunityIds(potentialId);
    const salesforceDatetime = moment(`${values.date} ${values.time}`, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

    await createDialerFollowUp({
      leadId,
      name: 'No Answer Follow-Up',
      opportunityId,
      origin: 'No Answer Journey Contact Request - MC',
      phoneNumber: /* user's phone number */ '',
      timeWindow: salesforceDatetime,
    });
  };

  // Event handlers
  return (
    <div className={classes.meetingContainer}>
      <div className='logoContainer'>
       <img className='logo' src={companyLogo} alt='וובי משווים וקונים ביטוח'/>
      </div>
      {showEnd && <div className={classes.doneMessege}>
      פנייתך התקבלה בהצלחה.
      <br/>
      נציג שלנו יצור איתך קשר בזמן המבוקש.
      </div>}
     {!showEnd && <div>
      <Formik
        initialValues={INITIAL_MEETING_VALUES}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        key={formKey} // Add key to Formik to force re-render
        enableReinitialize // Enable reinitialization
      >
        {({errors, touched, values, setFieldValue}) => (
           <Form >
            <Grid
              container
              spacing={2}
              className={classes.form}
            >
              {/* Card Details Section */}
              <Grid item className={classes.fieldWrapper}>
                <EzFormControl
                  name='meeting-date'
                  label={messages('fields.meetingDate')}
                  labelFor='meeting-date'
                  isLabelInChild
                >
                  <TextField
                    select
                    id='meeting-date'
                    labelId='meeting-date'
                    value={values.date}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      setFieldValue('date', selectedDate);
                      setFieldValue('time', '');
                      if (datesAndHoursConfig[selectedDate]) {
                        sethourOptions(datesAndHoursConfig[selectedDate]);
                      } else {
                        sethourOptions([]);
                      }
                    }}
                    size='small'
                    fullWidth
                    InputLabelProps={{className: classes.inputLabel}}
                  >
                    {dateOptions.map(dateKey => {
                    const m = moment(dateKey);
                    const formattedDate = m.format('DD-MM-YYYY');
                    const daysHebrew = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];
                    const dayName = daysHebrew[m.day()];

                    return (
                      <MenuItem key={dateKey} value={dateKey}>

                        {`${formattedDate} ${dayName}`}
                      </MenuItem>
                    );
                  })}
                  </TextField>
                </EzFormControl>
              </Grid>

              <Grid item className={classes.fieldWrapper}>
                <EzFormControl
                  name='meeting-time'
                  label={messages('fields.meetingHour')}
                  labelFor='meeting-time'
                  isLabelInChild
                >
                  <TextField
                    select
                    id='meeting-time'
                    labelId='meeting-time'
                    value={values.time}
                    onChange={(e) => setFieldValue('time', e.target.value)}
                    fullWidth
                    size='small'
                    InputLabelProps={{className: classes.inputLabel}}
                  >
                    {hourOptions.map(month => (
                      <MenuItem key={`month-${month}`} value={month}>{month}</MenuItem>
                    ))}
                  </TextField>
                </EzFormControl>
              </Grid>

              <Grid item xs={12} sm={6} className={classes.ScheduleBtnWrapper}>
                <Button
                  className={classes.ScheduleBtn}
                  type='submit'
                  disabled={isVerifyingPayment}
                  data-testid='Schedule-btn'
                >
                  {isFirstCard && !isUseCardForBoth ? messages('secure.payment.payment_continue_btn') : messages('secure.payment.payment_end_btn')}
                </Button>
                {isVerifyingPayment && (
                  <CircularProgress className={classes.verifyLoader} size={30} />
                )}
              </Grid>
            </Grid>
            {errors.date && touched.date && <div>{errors.date}</div>}
            {errors.time && touched.time && <div>{errors.time}</div>}
            {errors['is-future'] && <div>{errors['is-future']}</div>}
          </Form>
        )}
      </Formik>
      </div>}
    </div>
  );
}));

export default ScheduleCallPage;
